/**
 * @file Get an element width & height dimensions.
 * @author Selectra Front End Team
 * @version 1.0.0
 */


/**
 * @description A dimensions object, describing width and height.
 * @typedef {object} dimensions
 * @property {number} w - width
 * @property {number} h - height
 */


/**
 * @function getElementDimensions
 * @description Get an element dimensions ( width & height ), even if it has
 *     a display value of 'none'.
 * @param {object} element - A reference to the element for which we want the
 *     measures.
 * @param {boolean} [unClipped=true] - Disregard max-height & max-width.
 * @returns {dimensions} elementDimensions - Describes the element dimensions.
 */
export default function getElementDimensions( element, unClipped = true, displayValue = 'block' ) {

  const
    style = window.getComputedStyle( element ),
    display = style.display,
    hasInlineDisplay = !!element.style.display,
    position = style.position,
    hasInlinePosition = !!element.style.position,
    visibility = style.visibility,
    hasInlineVisibility = !!element.style.visibility,
    maxWidth = style.maxWidth,
    hasInlineMaxWidth = !!element.maxWidth,
    maxHeight = style.maxHeight,
    hasInlineMaxHeight = !!element.style.maxHeight;

  let
    width = element.offsetWidth,
    height = element.offsetHeight;

  if ( display === 'none' || maxHeight !== 'none' ) {

    element.style.visibility = 'hidden';

    if ( display === 'none' ) {
      element.style.display = displayValue;
    }

    if ( unClipped ) {
      element.style.maxHeight = 'none';
      element.style.maxWidth = 'none';
    }

    width = element.offsetWidth;
    height = element.offsetHeight;

    element.style.display = hasInlineDisplay ? display : '';
    element.style.position = hasInlinePosition ? position : '';
    element.style.visibility = hasInlineVisibility ? visibility : '';
    if ( unClipped ) {
      element.style.maxWidth = hasInlineMaxWidth ? maxWidth : '';
      element.style.maxHeight = hasInlineMaxHeight ? maxHeight : '';
    }

  }

  return {
    w: width,
    h: height,
  };

}
